export default __webpack_public_path__ + "static/media/LightBlue0004.c214b5dc.png";